import {useState, useEffect, useMemo} from 'react';
import Select from 'react-select';
import { useTheme } from '@mui/material';
import MikrotikV2Service from '../../services/mikrotikV2.service';

const SelectPanelesMikrotikV2 = ({id, value, onChange, isInvalid, isClearable,isMulti,isDisabled,modalTicket, nodoName}) => {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    const [items, setItems] = useState([]);
    const [options, setOptions] = useState([]);
    const [selectedValue, setSelectedValue] = useState();

    const onSelectValue = (ev) => {
        setSelectedValue(ev);
        onChange(ev);
    };
    const actualizar = async() =>{
        await MikrotikV2Service.getAllPaneles().then((response) => {
            if(nodoName){
                if(response?.length > 0){
                    const filtro = response.filter((nP)=> nP?.nodo === nodoName)
                    setItems(filtro);
                }
            }else{
                setItems(response);
            }
        });
    }
    useEffect(() => {
        actualizar();
    }, [nodoName]);
    const customStyles = useMemo(() => ({
        menuPortal: (base) => ({...base, zIndex: 9999}),
        menu: (provided) => ({
            ...provided,
            backgroundColor: isDarkMode ? '#2d3a52' : '#fff',
        }),
        option: (provided, state) => ({
            ...provided,
            color: state.isSelected ? (isDarkMode ? '#90caf9' : '#fff') : (isDarkMode ? '#e0e0e0' : '#000'),
            background: state.isSelected ? (isDarkMode ? '#1a3a5c' : '#0364ff') : (isDarkMode ? '#2d3a52' : '#fff'),
            '&:hover': {
                backgroundColor: isDarkMode ? '#3d4a62' : '#02378c',
                color: isDarkMode ? '#e0e0e0' : '#e0e0e0',
            },
        }),
        control: (styles) => ({
            ...styles,
            borderRadius: 7,
            borderColor: isDarkMode ? '#3d4a62' : 'gray',
            backgroundColor: isDarkMode ? '#2d3a52' : '#fff',
        }),
        singleValue: (provided) => ({
            ...provided,
            color: isDarkMode ? '#e0e0e0' : '#000',
        }),
        input: (provided) => ({
            ...provided,
            color: isDarkMode ? '#e0e0e0' : '#000',
        }),
        placeholder: (provided) => ({
            ...provided,
            color: isDarkMode ? '#b0bec5' : 'gray',
        }),
        multiValue: (styles, { data }) => {
            return {
                ...styles,
                backgroundColor: isDarkMode ? '#1a3a5c' : '#0364ff',
                borderRadius: 5,
                border: isDarkMode ? '1px solid #fff' : 'none'
            };
        },
        multiValueLabel: (styles, { data }) => ({
            ...styles,
            color: '#fff',
            borderRadius: 5
        }),
        multiValueRemove: (styles, { data }) => ({
            ...styles,
            color: '#fff',
            borderRadius: 5,
            '&:hover': {
                backgroundColor: '#02378c',
                color: '#fff',
            },
        }),
    }), [isDarkMode])
    useEffect(() => {
        const newOptions = items?.map((item) => {
            return {
                value: item?.nombre,
                label: item?.nombre,
                ...item
            };
        });
        setOptions(newOptions);
        if (typeof value === 'string' || typeof value === 'number') {
            setSelectedValue(
                newOptions.find((opt) => opt.value === value)
            );
        } else if(Array.isArray(value)){
            setSelectedValue(value?.map(va=>{
                const item = items?.find(it=>it?.nombre === va);
                if(item){
                    return {
                        label:item?.nombre,
                        value:item?.nombre,
                        ...item
                    };
                }
                return null
            }))
        }else{
            setSelectedValue(null)
        }
    }, [items,value]);

    return (
        <Select
            inputId={id}
            className={`react-select-container ${
                isInvalid ? 'is-invalid' : ''
            }`}
            styles={customStyles}
            menuPortalTarget={document.body}
            classNamePrefix="react-select"
            placeholder="Seleccione..."
            options={options}
            value={selectedValue}
            onChange={onSelectValue}
            isClearable={isClearable}
            isMulti={isMulti}
            menuShouldScrollIntoView
            menuPosition='absolute'
            menuPlacement='auto'
            isDisabled={isDisabled && modalTicket}
        />
    );
};

SelectPanelesMikrotikV2.defaultProps = {
    isClearable: false
};

export default SelectPanelesMikrotikV2;
